import { Component, inject, OnInit } from '@angular/core';
import { ToastModule } from 'primeng/toast';
import { MessageService } from 'primeng/api';
import { ToastService } from '../../services/toast.service';

@Component({
  selector: 'app-toast',
  standalone: true,
  imports: [ToastModule],
  providers: [MessageService],
  template: '<p-toast position="top-right" [life]="3000"></p-toast>',
})
export class ToastComponent implements OnInit {
  private readonly messageService = inject(MessageService);
  private readonly toastService = inject(ToastService);

  ngOnInit(): void {
    this.toastService.message$.subscribe((message) => {
      this.messageService.add({
        severity: message.severity,
        summary: message.summary,
        detail: message.detail,
        life: message.life,
      });
    });
  }
}
